import React from "react";
import FieldToggleMenu from "../../../Blocks/Menus/FieldToggleMenu/FieldToggleMenu";
import { appstr } from "@coreapp/utils/appstr";
import ColumnDisplayFieldTrigger from "./ColumnDisplayFieldTrigger";

/**
 * This component wraps the base FieldToggleMenu with defaults.
 * It accepts all props from FieldToggleMenu and allows overriding any prop while providing
 * column-specific defaults.
 *
 * @returns {React.ReactElement} FieldToggleMenu with column display defaults
 */
const ColumnDisplayFieldToggleMenu = ({
  dataTestId = "column-display-menu",
  dataTestIdPrefix = "column-display-menu-",
  listHeader = { label: appstr("Show and hide fields") },
  position = "bottom-end",
  listWidth = "large",
  stayAlive = true,
  selectedFieldNames,
  disabledFieldIds,
  localizationMap,
  ...menuProps
}) => {
  return (
    <FieldToggleMenu
      dataTestId={dataTestId}
      dataTestIdPrefix={dataTestIdPrefix}
      listHeader={listHeader}
      position={position}
      listWidth={listWidth}
      stayAlive={stayAlive}
      trigger={<ColumnDisplayFieldTrigger />}
      selectedFieldNames={selectedFieldNames}
      disabledFieldIds={disabledFieldIds}
      localizationMap={localizationMap}
      {...menuProps}
    />
  );
};

export default ColumnDisplayFieldToggleMenu;
